




















































import Vue from 'vue';

import {
  calender,
  brand,
  Brand,
  Booth,
  booth,
  item,
  Item,
  exhibitor,
  Exhibitor,
} from 'mostra';
import * as page from '@/modules/page';

interface DataType {
  loading: boolean;
  targetPageName: string;
  editPageName: string;
  // currentPage: string | (string | null)[];
  brand: Brand | null;
  booths: Booth[];
  items: Item[];
  exhibitors: Exhibitor[];
  notFound: boolean;
  owner: string | null;
}

const pageParams = page.tabParams.brand;

export default Vue.extend({
  name: 'exhibitor-brand-edit',
  data(): DataType {
    return {
      loading: true,
      // currentPage: '',
      // targetPageName: "exhibitor-brand-edit",
      targetPageName: 'admin-admin-brand-edit',
      editPageName: 'admin-admin-brand-edit',
      brand: null,
      booths: [],
      items: [],
      exhibitors: [],
      notFound: false,
      owner: null,
    };
  },
  computed: {
    brandId(): string | null {
      return this.$route.query.id as string;
    },
    currentPage(): string | null {
      return this.$route.query.page as string;
    },
  },
  methods: {
    formatDate(dt: any) {
      return calender.formatDate(dt);
    },
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    async fetchData() {
      try {
        if (this.brand) return;
        if (!this.brandId) {
          throw Error('brandId is null');
        }
        this.$loading(true);
        this.loading = true;

        // this.owner = this.$auth.cid;
        // if (!this.owner) throw Error('owner is null');

        this.brand = await brand.load(this.brandId);
        if (!this.brand) {
          this.notFound = true;
          return;
        }
        this.owner = this.brand.data.owner;
        if (!this.owner) throw Error('owner is null');
        this.exhibitors = await exhibitor.loadsByCID(this.owner);
        this.booths = await booth.loadsByBrandId(this.owner, this.brandId);
        this.items = await item.loadsByBrandId(this.owner, this.brandId);
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    async toUpdateData() {
      try {
        if (!this.brand) {
          throw Error('this.brand id null');
        }
        this.$loading(true);
        this.loading = true;
        const uid = this.$auth.uid;
        this.brand = await brand.save(uid, this.brand);
        this.$success('保存しました。');
        this.$router.push({
          name: this.editPageName,
          query: {
            page: 'preview',
            id: this.brand.id,
          },
        });
      } catch (error: any) {
        this.$error('保存に失敗しました。', error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    checkQueryParamsValid() {
      if (!this.currentPage || !pageParams.includes(this.currentPage)) {
        this.$router.push({
          name: this.targetPageName,
          // name: 'exhibitor-brand-edit',
          query: {
            ...this.$route.query,
            page: 'preview',
          },
        });
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    // this.currentPage = to.query.page;
    this.checkQueryParamsValid();
    await this.fetchData();
  },
  async mounted() {
    // this.currentPage = this.$route.query.page;
    this.checkQueryParamsValid();
    await this.fetchData();
  },
});

